<template>
  <div
    class="modal fade"
    :id="`book-${pipeline.id}`"
    tabindex="-1"
    aria-labelledby="devModal"
    aria-hidden="true"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="devModalLabel">
            <span v-if="booking.step === 1 && $route.name === 'manager_job_uuid'"
              >Book interview with {{ pipeline.first_name }} {{ pipeline.last_name }}</span
            >
            <span v-if="booking.step === 0 && $route.name === 'manager_job_uuid'"
              >Book interview with {{ pipeline.first_name }} {{ pipeline.last_name }}</span
            >
            <span v-if="booking.step === 1 && $route.name !== 'manager_job_uuid'"
              >Book interview</span
            >
            <span v-if="booking.step === 0 && $route.name !== 'manager_job_uuid'"
              >Book interview</span
            >
            <span v-if="booking.step === 2">Interview request</span>
          </h5>

          <button
            @click="clearDates"
            ref="closeBookModal"
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="booking.step === 1" class="modal-body">
          <p style="margin-bottom: 25px;">
            We recommend that you suggest several alternative time slots and not earlier than within
            24 hours. The time zone is according to your user settings.
          </p>
          <div
            v-for="(date, index) in booking.selectedDates"
            class="form-group m-label-left book-date"
          >
            <date-picker
              v-model="booking.selectedDates[index]"
              type="datetime"
              :value-type="'format'"
              :format="dateTimeFormat"
              :placeholder="dateTimeFormatPlaceholder"
              :disabled-date="disablePastDates"
              :time-picker-options="{
                start: '00:00',
                step: '00:30',
                end: '23:30',
              }"
              clearable
            />
            <label>Suggested start time #{{ index + 1 }}</label>
            <button
              v-if="index === booking.selectedDates.length - 1"
              style="margin-left: 12px;"
              @click="addDates(index)"
              type="button"
              class="btn btn-outline"
            >
              <i class="fas fa-plus-circle"></i>
            </button>
            <button
              v-if="index > 0"
              style="margin-left: 12px;"
              @click="removeDate(index)"
              type="button"
              class="btn btn-outline-danger"
            >
              <i class="fas fa-times-circle"></i>
            </button>
          </div>
          <div class="form-group m-label-left book-date">
            <select v-model="booking.selectedLocation" class="form-control">
              <option value="2">
                Face-to-face
              </option>
              <option value="1">
                Video
              </option>
              <option value="3">
                Phone call
              </option>
            </select>
            <label for="book-location">Location</label>
          </div>

          <div v-if="booking.selectedLocation === '2'" class="form-group m-label-left book-date">
            <input
              v-model="booking.selectedAddress"
              id="book-address"
              type="text"
              class="form-control"
            />
            <label for="book-address">Address</label>
          </div>

          <div v-if="booking.selectedLocation === '1'" class="form-group m-label-left book-date">
            <textarea
              v-model="booking.videoInstructions"
              id="book-instructions"
              rows="3"
              class="form-control"
            ></textarea>
            <label for="book-instructions">Instructions to join</label>
          </div>
          <div class="form-group m-label-left">
            <textarea
              v-model="booking.info"
              id="book-info"
              rows="4"
              class="form-control"
            ></textarea>
            <label for="book-info">Information about meeting</label>
          </div>
        </div>
        <div v-if="booking.step === 2" class="modal-body">
          <p>
            Thank you, we have received your request for an interview with
            <strong
              >{{ pipeline.first_name ? pipeline.first_name : getManagerCandidateById.first_name }}
              {{
                pipeline.last_name ? pipeline.last_name : getManagerCandidateById.last_name
              }}.</strong
            >
            You and the candidate will receive a calendar invite by email when the meeting is
            confirmed. Feel free to forward the meeting invite to additional participants if you
            want.
          </p>
        </div>
        <div v-if="booking.step === 0" class="modal-body">
          <p>
            We are sorry, but we don't assist in arranging interviews with the current service level
            for this job. We recommend that you contact the candidate directly via email to arrange
            an interview. If you want to upgrade service level, don't hesitate to contact us.
          </p>
        </div>
        <div v-if="booking.step === 1" class="modal-footer text-center justify-content-center">
          <button @click="bookDate" type="button" class="btn btn-primary">
            Request meeting
          </button>
          <button
            @click="clearDates"
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
        </div>
        <div v-if="booking.step === 2" class="modal-footer text-center justify-content-center">
          <button
            @click="booking.step = 1"
            type="button"
            class="btn btn-primary"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            OK
          </button>
        </div>
        <div v-if="booking.step === 0" class="modal-footer text-center justify-content-center">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close">
            OK
          </button>
          <button
            @click="goToSupport"
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            Contact Jobshark
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  props: {
    pipeline: {
      type: Object,
    },
  },
  components: {
    DatePicker,
  },
  data: () => ({
    selectedTimeConfirm: '',
    booking: {
      step: 1,
      selectedDates: [''],
      selectedLocation: '1',
      selectedAddress: '',
      videoInstructions: '',
      info: '',
    },
  }),
  methods: {
    goToSupport() {
      this.$router.push({ name: 'manager-support' });
    },

    disablePastDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },

    getTomorrowAtTenAM() {
      const date = new Date();
      date.setDate(date.getDate() + 1); // Add one day to the current date
      date.setHours(10); // Set the hour to 10 AM
      date.setMinutes(0); // Set the minutes to 00
      date.setSeconds(0); // Reset seconds
      date.setMilliseconds(0); // Reset milliseconds

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },

    getCurrentLocalDateWithZeroMinutesIndex(index) {
      const date = new Date();
      date.setDate(date.getDate() + 1); // Add one day to the current date
      date.setHours(10); // Set the hour to 10 AM
      date.setMinutes(0); // Set the minutes to 00
      date.setSeconds(0); // Reset seconds
      date.setMilliseconds(0); // Reset milliseconds

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      this.booking.selectedDates[index] = `${year}-${month}-${day}T${hours}:${minutes}`;
    },
    addDates(currentIndex) {
      if (this.booking.selectedDates.length < 10) {
        this.booking.selectedDates.push('');
        this.getCurrentLocalDateWithZeroMinutesIndex(currentIndex + 1);
      }
    },
    removeDate(index) {
      this.booking.selectedDates.splice(index, 1);
    },
    clearDates() {
      if (this.pipeline.service_level === 0 || this.pipeline.service_level === 1) {
        this.booking.step = 0;
      } else {
        this.booking.step = 1;
      }

      this.booking.selectedLocation = '1';
      this.booking.videoInstructions = '';
      this.booking.info = '';
      this.booking.selectedDates = [''];
      this.createAddress();
      this.booking.selectedDates = this.booking.selectedDates.map(date => date);
    },
    confirmDate() {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/manager/interview/approve`,
          {
            timeslot_id: this.selectedTimeConfirm,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.$refs.closeConfirmModal.click();
          this.$emit('update');
        })
        .catch(err => {
          console.log(err);
        });
    },

    bookDate() {
      const tz = this.getManagerUserProfile.timezone;
      const userFormat = this.getManagerUserProfile.format_date;

      // Match UI format to moment.js parsing format
      const formatMap = {
        'YY-MM-DD': 'YY-MM-DD HH:mm',
        'YY/MM/DD': 'YY/MM/DD HH:mm',
        'DD-MM-YY': 'DD-MM-YY HH:mm',
        'DD/MM/YY': 'DD/MM/YY HH:mm',
        'MM-DD-YY': 'MM-DD-YY HH:mm',
        'MM/DD/YY': 'MM/DD/YY HH:mm',
      };

      const fmt = formatMap[userFormat] || 'DD-MM-YY HH:mm';

      // Convert each to a string in UTC
      const selectedDatesUTC = this.booking.selectedDates.map(slot => {
        return moment.tz(slot, fmt, tz).format('YYYY-MM-DD HH:mm:ss');
      });

      axios
        .post(
          `${process.env.VUE_APP_API_URL}/manager/interview/create`,
          {
            pipeline_id: this.pipeline.id,
            location: Number(this.booking.selectedLocation),
            address: this.booking.selectedAddress,
            instructions: this.booking.videoInstructions,
            information: this.booking.info,
            timeslots_data: selectedDatesUTC, // now it's array of strings
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                `${process.env.VUE_APP_TOKEN_PREFIX}token`,
              )}`,
            },
          },
        )
        .then(res => {
          this.booking.step++;
          this.$emit('update');
          this.booking.selectedDates = [''];
          this.booking.selectedLocation = '1';
          this.booking.videoInstructions = '';
          this.booking.info = '';
          this.createAddress();
        })
        .catch(err => {
          console.error('Booking error:', err);
        });
    },
    createAddress() {
      if (this.pipeline.employer_address.address) {
        this.booking.selectedAddress = `${this.pipeline.employer_address.address}`;
      }
      if (this.pipeline.employer_address.postal_code) {
        this.booking.selectedAddress =
          this.booking.selectedAddress +
          `, ${this.pipeline.employer_address.postal_code} ${this.pipeline.employer_address.city}, ${this.pipeline.employer_address.country}`;
      }
    },
  },

  computed: {
    ...mapGetters(['getUserProfile', 'getCandidateById']),
    ...mapGetters('managerStoreModule', ['getManagerCandidateById', 'getManagerUserProfile']),
    minDate() {
      return new Date().toISOString().slice(0, 16);
    },

    dateTimeFormat() {
      // assume getUserProfile.format_date is something like "MM-dd-yyyy"
      return `${this.getManagerUserProfile.format_date} HH:mm`;
      // or for 12-hour clock with AM/PM:
      // return `${this.getUserProfile.format_date} hh:mm a`
    },
    dateTimeFormatPlaceholder() {
      // assume getUserProfile.format_date is something like "MM-dd-yyyy"
      return `${this.getManagerUserProfile.format_date} hh:mm`;
      // or for 12-hour clock with AM/PM:
      // return `${this.getUserProfile.format_date} hh:mm a`
    },
  },
  mounted() {
    this.createAddress();
    this.booking.selectedDates = this.booking.selectedDates.map(date => date);
    if (this.pipeline.service_level === 0 || this.pipeline.service_level === 1) {
      this.booking.step = 0;
    }
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.book-date {
  display: flex;
  margin-bottom: 20px;
  .form-control {
    margin-bottom: 0 !important;
  }
  .btn-outline {
    border: 1px solid rgba(0, 0, 0, 0.2);
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
    i {
      color: #5bb75b;
    }
    &:hover {
      background-color: #5bb75b;
      i {
        color: #fff;
      }
    }
  }
}
</style>
